import React from 'react'
import { useIntl } from 'react-intl'
import type { FieldsConfiguration } from 'msp-components'
import { useConfig, useMultiSite } from 'msp-integrations'

export const newsletterCheckboxLabel = () => {
  const { formatMessage } = useIntl()
  const { buildUrl } = useMultiSite()
  const { title } = useConfig()
  return formatMessage(
    {
      defaultMessage:
        'Yes, I would like to receive the {title} News service by e-mail. Unsubscribe at any time. By submitting the form, you consent to receive the newsletter. Your consent also includes data processing outside the European Economic Area, in particular by providers in the USA, in accordance with Art. 49 (1) a) GDPR. The USA is assessed by the European Court of Justice as a country with an insufficient level of data protection according to the standard of the GDPR. In particular, there is a risk that your data may be processed by US authorities for control and monitoring purposes. You can unsubscribe from the newsletter at any time {unsubscribeLink}. Our privacy policy can be found {privacyPolicyLink}.',
      id: 'msp.newsletter_form.label.subscribe_darq_newsletter'
    },
    {
      title: title?.toUpperCase() || '',
      unsubscribeLink: (
        <a
          href={formatMessage({
            id: 'msp.newsletter_form.unsub_link',
            defaultMessage: 'https://cloud.my.avoury.com/unsub_en'
          })}
          target='blank'
          className='underline'
        >
          {formatMessage({
            id: 'msp.newsletter_form.link',
            defaultMessage: 'here'
          })}
        </a>
      ),
      privacyPolicyLink: (
        <a
          href={`${buildUrl(
            formatMessage({
              id: 'msp.newsletter_form.privacyPolicyUrl',
              defaultMessage: '/privacy'
            })
          )}`}
          target='blank'
          className='underline'
        >
          {formatMessage({
            id: 'msp.newsletter_form.link',
            defaultMessage: 'here'
          })}
        </a>
      )
    }
  )
}

const getNewsletterFields = (id: string = ''): FieldsConfiguration => {
  const { formatMessage } = useIntl()

  return {
    firstName: {
      id: 'firstName',
      type: 'text',
      name: 'firstName',
      placeholder: formatMessage({
        defaultMessage: 'First name',
        id: 'msp.newsletter_form.label.first_name'
      }),
      label: ''
    },
    lastName: {
      id: 'lastName',
      type: 'text',
      name: 'lastName',
      placeholder: formatMessage({
        defaultMessage: 'Last name',
        id: 'msp.newsletter_form.label.last_name'
      }),
      label: ''
    },
    email: {
      id: 'email',
      type: 'email',
      name: 'email',
      placeholder: formatMessage({
        defaultMessage: 'your@email.com*',
        id: 'msp.newsletter_form.label.email'
      }),
      label: '',
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter your email address.',
          id: 'msp.newsletter_form.error.required_email'
        })
      }
    },
    [`newsletter_${id}`]: {
      id: `newsletter_${id}`,
      type: 'checkbox',
      name: `newsletter_${id}`,
      placeholder: '',
      label: newsletterCheckboxLabel(),
      rules: {
        required: formatMessage({
          defaultMessage: 'You must select this checkbox.',
          id: 'msp.newsletter_form.error.required_terms_acceptance'
        })
      }
    }
  }
}

export default getNewsletterFields
